import { ChangeEvent, ChangeEventHandler } from 'react';

/**
 * Enforces a maximum string length programatically. Can be useful for browsers that
 * do not always enforce the traditional `maxlength` correctly
 */
const maxLengthValidator =
    <T extends HTMLInputElement | HTMLTextAreaElement>(onChange: ChangeEventHandler<T>) =>
    (e: ChangeEvent<T>) => {
        if (e.target.maxLength > 0 && e.target.value.length > e.target.maxLength) {
            e.target.value = e.target.value.slice(0, e.target.maxLength);
            e.preventDefault();
            return;
        } else {
            return onChange(e);
        }
    };
export default maxLengthValidator;
